import * as Err from '@fixtuur/error-context';
import * as E from 'fp-ts/Either';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import * as i from 'io-ts';
import { _ComplexProduct } from '../../fixtuur/configuration/complexProduct';
import { request } from '../../requests/getBasket';
import { RequestError } from '../../requests/requestError';
const BasketProduct = i.intersection([
    i.type({ productId: i.string, quantity: i.number, unitPrice: i.number }),
    i.partial({ options: _ComplexProduct }),
]);
const BasketProducts = i.array(BasketProduct);
const Basket = i.type({
    products: BasketProducts,
    price: i.number,
    currency: i.string,
});
const isBasket = (u) => E.isRight(Basket.decode(u));
export const get = (serviceUrls, particles, complexProduct) => {
    return pipe(request(serviceUrls.particles)({ particles, options: complexProduct }), TE.chain(({ response, basketUrl }) => {
        if (!isBasket(response.data)) {
            return TE.left(Err.construct(RequestError.ResponseNotExpectedFormat, {
                responseUrl: basketUrl,
                responseStatus: response.status.toString(10),
                responseStatusText: response.statusText,
            }));
        }
        return TE.right({
            products: response.data.products,
            price: response.data.price,
            currency: response.data.currency,
        });
    }));
};
